const CommonI18n_ptBr = {
  authError: {
    title: 'Não foi possível realizar autenticação',
    providerNotConfigured: 'FintechTokenProvider não configurado: chame setTokenProvider antes de iniciar o componente.',
    customerTokenUnavailable: 'Não foi possível obter o token de autenticação!',
    adminTokenUnavailable: 'Não foi possível obter o token de administrador!',
  },
};

export default CommonI18n_ptBr;
